import * as React from "react";
import { useContext, useState } from "react";
import { ServiceContext } from "src/services/provider/Service.provider";
import { ShowNotification } from "../../ShowNotification/ShowNotification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons";
import "./DownloadDocumentButton.scss";
import { IDocument } from "src/services/interfaces/IDocument";
import { DocumentCategoryLabel, DocumentCategoryEnum } from "src/components/Refatoracao/UploadDocument/DocumentCategoryEnum";

function DownloadDocument(props: { document: IDocument }) {
  const { documentService } = useContext(ServiceContext);

  const [loading, setLoading] = useState(false);

  const downloadDocument = (document: IDocument) => {
    setLoading(true);

    documentService.downloadDocument(document).catch((error) => {
      ShowNotification.Error("Falha na consulta", "Ocorreu um erro durante o Download. Tente novamente.")
    }).finally(() => setLoading(false));
  }

  return (
    <button disabled={loading} className="download-document btn" onClick={() => downloadDocument(props.document)}>
      <FontAwesomeIcon icon={faCloudDownloadAlt} />
      <span>{DocumentCategoryLabel.get(DocumentCategoryEnum[props.document.category]) || props.document.category}</span>
    </button>
  );
}

export default DownloadDocument;



// WEBPACK FOOTER //
// ./src/components/common/GenericButtons/DownloadDocument/DownloadDocumentButton.tsx